import React, { useState, useEffect, useRef } from "react";
import LoadingComponent from "@Components/LoadingComponent/LoadingComponent";
import themeCreator from "@Themes/themeCreator";
import PageTitle from "@Components/PageTitle/PageTitle";
import AssignmentRoundedIcon from "@mui/icons-material/AssignmentRounded";
import { Container } from "@mui/material";
import useSendPostRequest from "@Hooks/useSendPostRequest";
import DateSelector from "@Components/DateTimePickers/DatePicker";
import { formatDateUTC } from "../../../Utils/Validations/HelperFunctions/FormaterFunctions";
import MultiSelectionDropDown from "../../../Components/DropDown/MultiSelectionDropDown";
import {
  CLEARANCE_AGENTS_URL,
  CATEGORIES_URL,
  MATERIALS_URL,
  SUPPLIERS_URL,
  PLANNERS_URL,
  GET_PRESIGNED_LINK,
  SAVE_ORDER,
  EXISTS_BY_PO_NUMBER,
} from "../../../API/APIRoutes";
import axiosInstance from "@API/axios";
import SearchableDropDown from "@Components/DropDown/SearchableDropDown";
import Joi from "joi";
import { useNavigate } from "react-router-dom";

import {
  DropDownValidation,
  PONumberValidation,
  WithoutValidation,
} from "@Utils/Validations/UserValidations/UserValidationFieldsSchema";
import { submitFormWithValidation } from "@Utils/Validations/HelperFunctions/FormValidationFunctions";
import * as DefaultRoutes from "@Routes/DefaultRoutes";
import { origins } from "../../../Utils/HelpingObjects/HelpingObjects";
import {
  wayOfShippingOptions,
  Company,
} from "../../../Utils/HelpingObjects/HelpingObjects";
import {
  Grid,
  Typography,
  TextField,
  Button,
  Box,
  Chip,
  Checkbox,
  FormControlLabel,
  CircularProgress,
} from "@mui/material";
import { FormStyle } from "../../Styles/FormStyle";
import useGetManyRequests from "../../../Hooks/useGetManyRequests";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import axios from "axios";
import { useDispatch } from "react-redux";
import { setSnackbar } from "@Redux/snackBarSlice";
import { red } from "@mui/material/colors";
import CancelIcon from "@mui/icons-material/Cancel";
import UploadFileButton from "../../../Components/Buttons/uploadFileButton";
import { encryptId } from "../../../Utils/SecurityFunctions";

export default function AddNewOrders() {
  const validationSchema = Joi.object({
    categoryId: DropDownValidation("Category", false),
    agentId: DropDownValidation("Agency", false),
    poNumber: PONumberValidation("PO Number"),
    wayOfShipping: DropDownValidation("Way Of Shipping", false),
    relativeCompany: DropDownValidation("Relative Company", false),
    plannerId: DropDownValidation("Planner", false),
    supplierId: DropDownValidation("Supplier", false),
    materialIds: WithoutValidation,
    pfiObjectKey: WithoutValidation,
    pfiReceivalDate: WithoutValidation,
    origin: DropDownValidation("Origin", false),
    isSample: WithoutValidation,
  });
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const [categoryNameOptions, setCategoryNameOptions] = useState([]);
  const [agencyNameOptions, setAgencyNameOptions] = useState([]);
  const [plannerNameOptions, setPlannerNameOptions] = useState([]);
  const [supplierNameOptions, setSupplierNameOptions] = useState([]);
  const [materialNameOptions, setMaterialNameOptions] = useState([]);
  const [orderMaterials, setOrderMaterials] = useState([]);

  const initialOrderState = {
    categoryId: "",
    poNumber: "",
    wayOfShipping: "",
    agentId: "",
    plannerId: "",
    supplierId: "",
    materialIds: [],
    pfiObjectKey: "",
    pfiReceivalDate: "",
    relativeCompany: "",
    origin: "",
    isSample: false,
  };
  const [newOrderData, setnewOrderData] = useState(initialOrderState);
  const [poCheck, setPoCheck] = useState({ poNumber: "", checking: false, exists: false, error: false });
  const [duplicateAcknowledged, setDuplicateAcknowledged] = useState(false);
  const [acknowledgmentError, setAcknowledgmentError] = useState(false);
  const poCheckRequestId = useRef(0);
  const poCheckResult = useRef(null);
  const latestPoNumber = useRef("");
  const [isPfiFileRequired, setIsPfiFileRequired] = useState(true);
  const [pfiFileError, setpfiFileError] = useState("");
  const [pfifile, setpfiFile] = useState();
  const [pfiReceivalDateError, setpfiReceivalDateError] = useState("");
  const [addOrderLoading, setaddOrderLoading] = useState(false);
  const { isLoading: loading2, requestMethod: postData } =
    useSendPostRequest(true);
  const { isLoading: minioLoading, requestMethod: minioPostData } =
    useSendPostRequest();

  const { loading: getAllLoading, getAll } = useGetManyRequests();
  let urls = [
    CATEGORIES_URL,
    CLEARANCE_AGENTS_URL,
    PLANNERS_URL,
    SUPPLIERS_URL,
    MATERIALS_URL,
  ];

  const optionsMapping = [
    {
      index: 0,
      key: "categoryName",
      id: "categoryId",
      setter: setCategoryNameOptions,
    },
    { index: 1, key: "agentName", id: "agentId", setter: setAgencyNameOptions },
    {
      index: 2,
      key: "plannerName",
      id: "plannerId",
      setter: setPlannerNameOptions,
    },
    {
      index: 3,
      key: "supplierName",
      id: "supplierId",
      setter: setSupplierNameOptions,
    },
    {
      index: 4,
      key: "materialName",
      id: "materialId",
      setter: setMaterialNameOptions,
    },
  ];

  useEffect(() => {
    getAll(urls).then((res) => {
      optionsMapping.forEach(({ index, key, id, setter }) => {
        let options =
          res[index]?.map((item) => ({
            name: item[key],
            id: String(item[id]),
          })) || [];
        setter(options);
      });
    });
  }, []);

  const [errors, setErrors] = useState({});
  const theme = themeCreator();

  const checkPoNumber = (value) => {
    const poNumber = value.trim();
    if (!poNumber) return Promise.resolve(false);

    if (poCheckResult.current?.poNumber === poNumber) {
      if (poCheckResult.current.promise) return poCheckResult.current.promise;
      if (typeof poCheckResult.current.exists === "boolean") {
        return Promise.resolve(poCheckResult.current.exists);
      }
    }

    const requestId = ++poCheckRequestId.current;
    setPoCheck({ poNumber, checking: true, exists: false, error: false });
    const promise = axiosInstance
      .get(EXISTS_BY_PO_NUMBER, { params: { poNumber } })
      .then(({ data }) => {
        if (typeof data?.exists !== "boolean") {
          throw new Error("Invalid PO number check response");
        }
        const exists = data.exists;
        if (requestId === poCheckRequestId.current) {
          poCheckResult.current = { poNumber, exists };
          setPoCheck({ poNumber, checking: false, exists, error: false });
        }
        return exists;
      })
      .catch(() => {
        if (requestId === poCheckRequestId.current) {
          poCheckResult.current = null;
          setPoCheck({ poNumber, checking: false, exists: false, error: true });
        }
        return null;
      });
    poCheckResult.current = { poNumber, promise };
    return promise;
  };

  // Handle form submission
  const handleOnSubmit = async (event) => {
    event.preventDefault();
    let materialIds = orderMaterials.map((material) => {
      return material.id;
    });
    const formattedData = {
      ...newOrderData,
      materialIds: materialIds,
      pfiReceivalDate: formatDateUTC(newOrderData.pfiReceivalDate),
    };
    try {
      // Validate the form data

      const newOrder = await submitFormWithValidation(
        formattedData,
        false,
        null,
        setErrors,
        validationSchema
      );

      // Validate form data
      let validationFailed = false;

      if (newOrder == null) validationFailed = true;

      if (!fileName && isPfiFileRequired) {
        setpfiFileError("File Is Required.");
        validationFailed = true;
      }

      if (!newOrderData.pfiReceivalDate && isPfiFileRequired) {
        setpfiReceivalDateError("PFI Receival Date Is Required");
        validationFailed = true;
      }
      if (orderMaterials?.length == 0) {
        setErrors({
          ...errors,
          materialIds: "At least one Material must be selected",
        });
      }

      if (validationFailed) return;

      const checkedPoNumber = newOrderData.poNumber.trim();
      const poNumberExists = await checkPoNumber(checkedPoNumber);
      if (
        poNumberExists === null ||
        latestPoNumber.current.trim() !== checkedPoNumber
      ) return;
      if (poNumberExists && !duplicateAcknowledged) {
        setAcknowledgmentError(true);
        return;
      }

      if (!isPfiFileRequired) {
        newOrder.pfiObjectKey = null;
        newOrder.pfiReceivalDate = null;
        setaddOrderLoading(true);
        let res = await postData(
          SAVE_ORDER,
          newOrder,
          null,
          "Order Created Successfully"
        );
        clearData();
        setaddOrderLoading(false);
        if (res?.data)
          navigate(
            DefaultRoutes.orderInfo.replace(":orderId", encryptId(res.data))
          );

        return;
      }

      // Get the presigned URL
      setaddOrderLoading(true);
      const response = await minioPostData(GET_PRESIGNED_LINK, {
        fileName: pfifile.name,
      });
      if (!response.data.preSignedUrl) {
        throw new Error("Presigned URL not received");
      }

      const { preSignedUrl, objectKey } = response.data;

      // Upload file to Minio
      await axios.put(preSignedUrl, pfifile, {
        headers: {
          "Content-Type": "application/pdf",
        },
      });

      // Update order with uploaded file reference
      newOrder.pfiObjectKey = objectKey;

      // Save the order
      let res = await postData(
        SAVE_ORDER,
        newOrder,
        null,
        "Order Created Successfully"
      );
      clearData();
      setaddOrderLoading(false);
      if (res?.data)
        navigate(
          DefaultRoutes.orderInfo.replace(":orderId", encryptId(res.data))
        );
    } catch (error) {
      setaddOrderLoading(false);
    }
  };
  const onDatePick = (newValue) => {
    setnewOrderData({ ...newOrderData, pfiReceivalDate: newValue });
    setErrors({ ...errors, pfiReceivalDateError: "" });
  };
  const clearData = () => {
    setnewOrderData(initialOrderState);
    latestPoNumber.current = "";
    poCheckRequestId.current += 1;
    poCheckResult.current = null;
    setPoCheck({ poNumber: "", checking: false, exists: false, error: false });
    setDuplicateAcknowledged(false);
    setAcknowledgmentError(false);
    setErrors({});
    setpfiFileError("");
    setFileName("");
    setpfiFile("");
    setpfiReceivalDateError("");
    setMaterialNameOptions([...materialNameOptions, ...orderMaterials]);
    setOrderMaterials([]);
  };

  const [fileName, setFileName] = useState("");

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (!file) {
      setpfiFileError("File Is Required.");
      return;
    }
    setpfiFile(file);
    setFileName(file.name);
    setpfiFileError("");
  };
  const clearSelectedFile = () => {
    setpfiFile(null);
    setFileName("");
    setpfiFileError("");
  };
  const handleChange = (e) => {
    const poNumber = e.target.value;
    latestPoNumber.current = poNumber;
    poCheckRequestId.current += 1;
    poCheckResult.current = null;
    setPoCheck({ poNumber: "", checking: false, exists: false, error: false });
    setDuplicateAcknowledged(false);
    setAcknowledgmentError(false);
    setErrors((previous) => ({ ...previous, poNumber: "" }));
    setnewOrderData((previous) => ({ ...previous, poNumber }));
  };

  const form = (
    <>
      {
        <form onSubmit={handleOnSubmit} className="formWrapper">
          <Grid
            className="inputContainer"
            container
            spacing={2}
            justifyContent="flex-end"
          >
            <Grid item xs={12}>
              <Typography variant="body1" sx={{ mb: 1 }} align="left">
                PO Number
              </Typography>
              <TextField
                variant="outlined"
                fullWidth
                placeholder="PO Number"
                value={newOrderData.poNumber ?? ""}
                onChange={handleChange}
                onBlur={() => checkPoNumber(newOrderData.poNumber)}
                helperText={
                  <Typography variant="body2" marginTop={1} color={"error"}>
                    {errors.poNumber || ""}
                  </Typography>
                }
              />
              {poCheck.poNumber === newOrderData.poNumber.trim() && poCheck.checking && (
                <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: 1 }}>
                  <CircularProgress size={16} />
                  <Typography variant="body2">Checking PO number...</Typography>
                </Box>
              )}
              {poCheck.poNumber === newOrderData.poNumber.trim() && poCheck.error && (
                <Typography variant="body2" color="error" sx={{ mt: 1 }}>
                  Could not check the PO number. Please try again.
                </Typography>
              )}
              {poCheck.poNumber === newOrderData.poNumber.trim() && poCheck.exists && (
                <Box sx={{ mt: 1 }}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={duplicateAcknowledged}
                        inputProps={{ "aria-required": true }}
                        onChange={(event) => {
                          setDuplicateAcknowledged(event.target.checked);
                          setAcknowledgmentError(false);
                        }}
                      />
                    }
                    label="I understand that an order with this PO number already exists."
                  />
                  {acknowledgmentError && (
                    <Typography variant="body2" color="error">
                      Please confirm before submitting this order.
                    </Typography>
                  )}
                </Box>
              )}
            </Grid>
            <Grid item xs={6}>
              <Typography variant="body1" sx={{ mb: 1 }}>
                Category
              </Typography>
              <SearchableDropDown
                state={newOrderData.categoryId}
                setState={(value) => {
                  setnewOrderData({ ...newOrderData, categoryId: value });
                  setErrors({ ...errors, categoryId: "" }); // Clear error message on selection
                }}
                name="categoryId"
                label=""
                placeholder="Select Category Name"
                items={categoryNameOptions}
                helperText={errors.categoryId}
              />
            </Grid>
            <Grid item xs={6}>
              <Typography variant="body1" sx={{ mb: 1 }}>
                Agency Name
              </Typography>
              <SearchableDropDown
                state={newOrderData.agentId}
                setState={(value) => {
                  // Find Galaxy Suez agentId
                  const galaxySuez = agencyNameOptions.find(
                    (option) => option.name === "Galaxy Suez"
                  );
                  const elAmal = agencyNameOptions.find(
                    (option) => option.name === "El-Amal"
                  );
                  const galaxySuezAgentId = galaxySuez ? galaxySuez.id : null;
                  setIsPfiFileRequired((value !== galaxySuezAgentId) && newOrderData.isSample === false);
                  setnewOrderData({ ...newOrderData, agentId: value });
                  setErrors({ ...errors, agentId: "" }); // Clear error message on selection
                }}
                name="agent"
                label=""
                placeholder="Select Agency Name"
                items={agencyNameOptions}
                helperText={errors.agentId}
              />
            </Grid>
            <Grid item xs={6}>
              <Typography variant="body1" sx={{ mb: 1 }}>
                Planner Name
              </Typography>
              <SearchableDropDown
                state={newOrderData.plannerId}
                setState={(value) => {
                  setnewOrderData({ ...newOrderData, plannerId: value });
                  setErrors({ ...errors, plannerId: "" }); // Clear error message on selection
                }}
                name="planner"
                label=""
                placeholder="Select Planner Name"
                items={plannerNameOptions}
                helperText={errors.plannerId}
              />
            </Grid>
            <Grid item xs={6}>
              <Typography variant="body1" sx={{ mb: 1 }}>
                Supplier Name
              </Typography>
              <SearchableDropDown
                state={newOrderData.supplierId}
                setState={(value) => {
                  setnewOrderData({ ...newOrderData, supplierId: value });
                  setErrors({ ...errors, supplierId: "" }); // Clear error message on selection
                }}
                name="supplier"
                label=""
                placeholder="Select Supplier Name"
                items={supplierNameOptions}
                helperText={errors.supplierId}
              />
            </Grid>
            <Grid item xs={6}>
              <Typography variant="body1" sx={{ mb: 1 }}>
                Origin Name
              </Typography>
              <SearchableDropDown
                state={newOrderData.origin}
                setState={(value) => {
                  setnewOrderData({ ...newOrderData, origin: value });
                  setErrors({ ...errors, origin: "" }); // Clear error message on selection
                }}
                name="origin"
                label=""
                placeholder="Select Origin Name"
                items={origins}
                helperText={errors.origin}
              />
            </Grid>
            <Grid item xs={6}>
              <Typography variant="body1" sx={{ mb: 1 }}>
                Relative Company
              </Typography>
              <SearchableDropDown
                state={newOrderData.relativeCompany}
                setState={(value) => {
                  setnewOrderData({
                    ...newOrderData,
                    relativeCompany: value,
                  });
                  setErrors({ ...errors, relativeCompany: "" }); // Clear error message on selection
                }}
                name="relativeCompany"
                label=""
                placeholder="Select Relative Company"
                items={Company}
                helperText={errors.relativeCompany}
              />
            </Grid>
                        <Grid item xs={12}>
              <Typography variant="body1" sx={{ mb: 1 }}>
                Material
              </Typography>
              <MultiSelectionDropDown
                state=""
                setState={(value) => {
                  setOrderMaterials([
                    ...orderMaterials,
                    materialNameOptions.find((item) => item.id === value),
                  ]);
                  setMaterialNameOptions(
                    materialNameOptions.filter((item) => item.id !== value)
                  );
                  setErrors({ ...errors, materialIds: "" }); // Clear error message on selection
                }}
                name="material"
                label=""
                placeholder="Select Material Name"
                items={materialNameOptions}
                helperText={errors.materialIds}
              />
            </Grid>
            <Grid item xs={12}>
              <Box
                sx={{
                  display: "flex",
                  flexWrap: "wrap", // Allow chips to wrap to new lines
                  alignItems: "flex-start", // Align to the top, matching the above fields
                  justifyContent: "flex-start", // Align to the left, matching the above fields
                  mt: 1, // Add a little margin to separate from above
                  gap: 1, // Add space between chips
                }}
              >
                {[...orderMaterials].map((value, idx) => (
                  <Chip
                    key={idx}
                    label={value.name}
                    size="small"
                    sx={{
                      fontWeight: 520,
                      mr: 1,
                      "& .MuiChip-icon": {
                        color: red[600], // green color
                      },
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      setOrderMaterials(
                        orderMaterials.filter((item) => item !== value)
                      );
                      setMaterialNameOptions([...materialNameOptions, value]);
                    }}
                    icon={<CancelIcon />}
                  />
                ))}
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="body1" sx={{ mb: 1 }}>
                Way Of Shipping
              </Typography>
              <SearchableDropDown
                state={newOrderData.wayOfShipping}
                setState={(value) => {
                  setpfiReceivalDateError("");
                  clearSelectedFile();
                  // Find Galaxy Suez agentId
                  const galaxySuez = agencyNameOptions.find(
                    (option) => option.name === "Galaxy Suez"
                  );
                  const elAmal = agencyNameOptions.find(
                    (option) => option.name === "El-Amal"
                  );
                  const galaxySuezAgentId = galaxySuez ? galaxySuez.id : null;
                  setIsPfiFileRequired((newOrderData.agentId !== galaxySuezAgentId) && newOrderData.isSample === false);
                  setnewOrderData({
                    ...newOrderData,
                    wayOfShipping: value,
                    pfiReceivalDate: "",
                  });
                  setErrors({ ...errors, wayOfShipping: "" }); // Clear error message on selection
                }}
                name="WayOfShipping"
                label=""
                placeholder="Select Way Of Shipping"
                items={wayOfShippingOptions}
                helperText={errors.wayOfShipping}
              />
            </Grid>
            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={Boolean(newOrderData.isSample)}
                    onChange={(e) => {
                      const isSampleChecked = e.target.checked;
                      const galaxySuez = agencyNameOptions.find(
                        (option) => option.name === "Galaxy Suez"
                      );
                      const galaxySuezAgentId = galaxySuez ? galaxySuez.id : null;
                      setIsPfiFileRequired(
                        isSampleChecked ? false : newOrderData.agentId !== galaxySuezAgentId
                      );
                      setnewOrderData({
                        ...newOrderData,
                        isSample: isSampleChecked,
                      });
                    }}
                  />
                }
                label="Is Sample ?"
              />
            </Grid>
            {isPfiFileRequired && (
              <Grid item xs={12}>
                <DateSelector
                  name={"PFI Receival Date"}
                  value={newOrderData.pfiReceivalDate}
                  error={errors.pfiReceivalDate}
                  onPick={onDatePick}
                />
                {pfiReceivalDateError && (
                  <Typography color="error" variant="body2" sx={{ mt: 1 }}>
                    {pfiReceivalDateError}
                  </Typography>
                )}
              </Grid>
            )}
            {isPfiFileRequired && (
              <Grid item xs={12}>
                <UploadFileButton
                  handleFileChange={handleFileChange}
                  fileName={fileName}
                  fileError={pfiFileError}
                  acceptedTypes={["application/pdf"]}
                  errorMessage="Only PDF files are allowed."
                  buttonLabel={pfifile ? "Change File" : "Upload PFI"}
                  buttonVariant="outlined"
                  buttonStartIcon={
                    pfifile ? <AttachFileIcon /> : <CloudUploadIcon />
                  }
                  fullWidth={true}
                  dragAndDrop={true}
                  sx={{
                    backgroundColor: pfifile
                      ? "rgba(25, 118, 210, 0.08)"
                      : "transparent",
                  }}
                />
              </Grid>
            )}
            <Box className="submissionBox">
              <Button
                type="submit"
                variant="contained"
                className="submissionButton"
                size="large"
                sx={{ mt: 2, ml: 2 }}
                disabled={addOrderLoading}
              >
                {!addOrderLoading ? (
                  "Add Order"
                ) : (
                  <LoadingComponent size="2em" thickness={5} color="white" />
                )}
              </Button>
            </Box>
          </Grid>
        </form>
      }
    </>
  );

  if (getAllLoading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height={theme.pageHeight}
      >
        <LoadingComponent />
      </Box>
    );
  }

  return (
    <FormStyle className="PageContainer">
      <Container
        sx={{ pb: 5, pr: "0px !important", pl: "0px !important" }}
        disableGutters
      >
        <Box className="LabelButtonBox">
          <PageTitle
            title={"New Order"}
            PageIcon={<AssignmentRoundedIcon color="white" fontSize="large" />}
            iconColor={theme.palette.primary.main}
          ></PageTitle>
        </Box>
        <Box sx={{ pt: 3 }}>{form}</Box>
      </Container>
    </FormStyle>
  );
}
